import React from 'react';
import { Route } from 'react-router-dom';
import { L } from '../../lib/i18n';
import { SettingsPage } from './SettingsPage';

export const routes = [<Route key="3" path="/settings" component={SettingsPage} />];

export const navigation = [{ name: L('projects'), link: '/settings', icon: 'Project' }];
